export function isValidEthiopianPhone(phone: string): boolean {
  return /^(\+251|0)9\d{8}$/.test(phone);
}

export function isValidName(name: string): boolean {
  return name.trim().length >= 2;
}
